import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyInfortuniService {
    static byAzienda = (id_azienda, anno = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/byAzienda`;
            const payload = { id_azienda };
            if (anno) payload.anno = anno;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static stats = (id_azienda, anno = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/stats`;
            const payload = { id_azienda };
            if (anno) payload.anno = anno;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static getOreLavoro = (id_azienda, anno = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/oreLavoroGet`;
            const payload = { id_azienda };
            if (anno) payload.anno = anno;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static setOreLavoro = (id_azienda, anno, ore_lavorate_annue) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/oreLavoroSet`;
            ApiService.postRequest(resolve, reject, url, { id_azienda, anno, ore_lavorate_annue });
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/create`;
        return ApiService.postFormData(url, formData);
    };

    static deleteInfortunio = (id_infortunio) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/delete`;
            ApiService.postRequest(resolve, reject, url, { id_infortunio });
        });
    };

    static download = (id_infortunio, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/infortuni/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_infortunio, filename });
        });
    };
}
